var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex justify-between items-baseline mb-10 py-2 px-4 border-b border-gray-200",
    },
    [
      _c("h3", { staticClass: "text-xl font-medium leading-6 text-gray-700" }, [
        _vm._v(" " + _vm._s(_vm._f("capitalize")(_vm.title)) + " "),
      ]),
      _vm._t("default"),
      _vm._t("actions"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }